import { UpsellProductRulesDto } from "@intelligems/ig-types/dtos/upsell-product-rules";

export interface IUpsellProductRulesState {
  isSuccess: boolean;
  upsellProductRules: UpsellProductRulesDto[];
  storedUpsellProductRules: UpsellProductRulesDto[];
}

export const initialIUpsellProductRulesState: IUpsellProductRulesState = {
  isSuccess: false,
  upsellProductRules: [],
  storedUpsellProductRules: [],
};
